import { PromptChips } from '../prompt-chips/prompt-chips';

interface BizySidePanelSuggestedPromptsProps {
	fontSize?: 'sm' | 'md';
	prompts: string[];
	onSelectPrompt: (prompt: string) => void;
	layout?: 'vertical' | 'horizontal';
}

export function BizySidePanelSuggestedPrompts({ fontSize, prompts, onSelectPrompt, layout = 'vertical' }: BizySidePanelSuggestedPromptsProps) {
	return <PromptChips fontSize={fontSize} prompts={prompts} onSelectPrompt={(prompt) => onSelectPrompt(prompt)} layout={layout} />;
}
